import React, { useEffect, useState } from "react";
import { Button, Form, Input, message } from "antd";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import moment from "moment";
import { useNavigate } from 'react-router-dom';

import {
  getAuthenticatorDetailsAPI,
  send2faOtpAPI,
} from "../services/auth.service";

import { userSignOut, verifyOtp } from "../appRedux/actions";

const FormItem = Form.Item;

const totalSeconds = 60;
const VerifyAccountForm = (props) => {
  const { submitting, authUser, form } = props;
  const { getFieldDecorator } = form;
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [disabled, setDisabled] = useState(true);
  const [seconds, setSeconds] = useState(totalSeconds);

  useEffect(() => {
    async function handleSendCode() {
      try {
        const response = await getAuthenticatorDetailsAPI({
          email: authUser.email,
          mode: "EMAIL",
        });
        if (!response.success)
          throw new Error("Error in sending OTP, please try again!");

        message.success("OTP sent successfully!");
      } catch (error) {
        message.error(
          error.message || "Something went wrong, please try again!"
        );
      } finally {
        setLoading(false);
      }
    }
    handleSendCode();
  }, []);

  useEffect(() => {
    if (!authUser) {
      navigate("/signin");
    }
    if (authUser && authUser.authenticated) {
      navigate("/");
    }
  }, [authUser, navigate]);

  useEffect(() => {
    if (
      authUser &&
      authUser.twoFactorAuthType === "EMAIL" &&
      !authUser.authenticated
    ) {
      const counter = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else {
          clearInterval(counter);
          setDisabled(false);
        }
      }, 1000);
      return () => {
        clearInterval(counter);
      };
    }
  }, [authUser, seconds]);

  const handleSubmit = (e) => {
    e.preventDefault();
    form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        const data = {
          email: authUser.email,
          code: values.code,
          mode: "EMAIL",
        };
        try {
          await props.verifyOtp(data); // waits for API to finish
        } finally {
          setLoading(false); // always stop loader
        }
      }
    });
  };

  const resendOtp = async () => {
    const response = await send2faOtpAPI(authUser.userId, authUser.email);
    if (response.success) {
      setSeconds(totalSeconds);
      setDisabled(true);
      message.success("OTP sent successfully!");
    } else {
      message.error("Failed to send OTP.");
    }
  };

  return (
    <section className="auth-layout-container">
      <div className="gx-app-login-wrap">
        <div className="verify-container">
          <div>
            <h1 className="authenticator-heading">
              Enter the 6-digit Code from the Email
            </h1>
          </div>
          <div className="verify-container-block">
            <div className="gx-app-login-content">
              <Form
                initialValues={{ remember: false }}
                name="basic"
                onSubmit={handleSubmit}
                style={{ display: "flex", flexDirection: "column", gap: "20px" }}
              >
                <FormItem label={<span className="label-otp">Enter Code</span>}>
                  {getFieldDecorator("code", {
                    initialValue: "",
                    rules: [
                      {
                        required: true,
                        message: "Please input OTP!!",
                        whitespace: false,
                        len: 6,
                      },
                    ],
                  })(<Input type="number" maxLength={6} />)}
                </FormItem>
                <p style={{ textAlign: "center", fontWeight: 400 }}>
                  Didn't receive the OTP?{" "}
                  {authUser && authUser.twoFactorAuthType === "EMAIL" && (
                    <Button
                      type="link"
                      loading={submitting}
                      disabled={disabled}
                      onClick={resendOtp}
                    >
                      Resend OTP
                    </Button>
                  )}
                  {authUser && authUser.twoFactorAuthType === "EMAIL" && (
                    <p style={{ marginTop: "10px", marginBottom: "0px" }}>
                      Resent OTP in &nbsp;
                      <span style={{ color: "#82C9D7" }}>
                        {moment.utc(seconds * 1000).format("mm:ss")}
                      </span>
                    </p>
                  )}
                </p>
                <p style={{ textAlign: "center", padding: '0 15px' }}>
                  We've sent a 6-digit verification code to your registered email. Please enter it to continue.
                </p>

                <Button
                  block
                  type="primary"
                  loading={loading || submitting}
                  htmlType="submit"
                >
                  {"Verify"}
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const VerifyAccount = Form.create()(VerifyAccountForm);

export const mapDispatchToProps = (dispatch) => ({
  verifyOtp: bindActionCreators(verifyOtp, dispatch),
  userSignOut: bindActionCreators(userSignOut, dispatch),
});

const mapStateToProps = ({ auth }) => {
  return {
    submitting: auth.submitting,
    authUser: auth.authUser || null,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(VerifyAccount);
